import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import moment from "moment";
const checkAndUpdate = ({ resultDates, current }) => {
  const monthYearFormatter = current.format("YYYY-MM");
  if (resultDates.has(monthYearFormatter)) {
    const prevValues = resultDates.get(monthYearFormatter);
    resultDates.set(monthYearFormatter, [
      ...prevValues,
      current.format("YYYY-MM-DD"),
    ]);
  } else {
    resultDates.set(monthYearFormatter, [current.format("YYYY-MM-DD")]);
  }
};
const addingValues = ({ current, endDate, interval, resultDates, unit }) => {
  while (current.isSameOrBefore(endDate)) {
    checkAndUpdate({ resultDates, current });
    current.add(interval, unit);
  }
};

export const everyRelatedCalculation = (eventDetailModal) => {
  let startDate = moment(new Date(eventDetailModal.date)); // today's date
  let endDate = moment(new Date(eventDetailModal?.repeatedEndDate)); // end date

  // Get the weekday to match (e.g., Monday, Tuesday, etc.)
  const targetWeekday = startDate.day(); // 0 (Sunday) - 6 (Saturday)

  let current = startDate.clone();
  const resultDates = new Map();
  switch (eventDetailModal?.repeatedType) {
    case 4:
      while (current.isSameOrBefore(endDate)) {
        // Check if the current date is on the same weekday
        if (current.day() === targetWeekday) {
          // resultDates.push(current.format("YYYY-MM-DD"));
          checkAndUpdate({ resultDates, current });
        }
        // Add 2 weeks (14 days)
        current.add(14, "days");
      }
      break;
    case 5:
      addingValues({
        current,
        endDate,
        interval: 1,
        resultDates,
        unit: "month",
      });
      break;
    case 6:
      addingValues({
        current,
        endDate,
        interval: 1,
        resultDates,
        unit: "year",
      });
      break;
    default:
      break;
  }

  return resultDates;
};

const selectedDatesCheck = ({
  multipleDates,
  endDate,
  interval,
  resultDates,
  unit,
}) => {
  multipleDates.forEach((element) => {
    let startedDate = element.clone();
    addingValues({
      current: startedDate,
      endDate,
      interval,
      resultDates,
      unit,
    });
  });
};
function getWeekDates(weekDates, startOfMonth, days, weekNumber) {
  const monthStart = startOfMonth.clone().startOf("month");
  const monthEnd = startOfMonth.clone().endOf("month");
  const isLastWeek = weekNumber === addEditEventsConst.firstToLast[5].id;
  const multipleDaysSelected = days.length > 1;
  // Set initial date to iterate from
  let weekStartDate = isLastWeek
    ? monthEnd.clone().subtract(6, "day")
    : monthStart.clone();

  for (let i = 0; i < 7; i++) {
    const currentDate = weekStartDate.clone().add(i, "days");
    const isValidDay = days.includes(currentDate.day());
    if (!isLastWeek && isValidDay) {
      currentDate.add(weekNumber - 1, "week");
    }
    // Check if the date is still in the target month and is a selected day
    if (currentDate.month() === startOfMonth.month() && isValidDay) {
      // weekDates.push(currentDate.format("YYYY-MM-DD"));
      checkAndUpdate({ resultDates: weekDates, current: currentDate });

      // Stop early if we only need one date and it's not a multi-day or last-week case
      // Break after full week if multiple days or last week case
      if (!multipleDaysSelected && !isLastWeek) {
        break;
      }
    }
  }
}
const addingValuesForSelectedAnyWeekdayFromMonth = ({
  current,
  endDate,
  resultDates,
  values,
  unit,
}) => {
  // values.monthWeekNumber for which week
  // values.DaysOfWeek for which day
  while (current.isSameOrBefore(endDate)) {
    const startOfMonth = moment(current.clone())
      .startOf("month")
      .format("YYYY-MM-DD");
    // for week day selection which is selected
    getWeekDates(
      resultDates,
      moment(startOfMonth),
      values.daysOfWeek.map((res) => (res.dayOfWeek === 7 ? 0 : res.dayOfWeek)),
      values.monthWeekNumber
    );

    current.add(values.interval, unit);
  }
};

export const everyCustomRelatedCalculation = (eventDetailModal) => {
  let startDate = moment(new Date(eventDetailModal.date)); // today's date
  let endDate = moment(new Date(eventDetailModal?.repeatedEndDate)); // end date
  const values = eventDetailModal.customRepeatPattern;
  const { showType: unit } = addEditEventsConst.repeatOptionsFrequency.find(
    (res) => res.id === values?.unit
  );

  const resultDates = new Map();
  let current = startDate.clone();

  switch (values.unit) {
    // for Daily
    case addEditEventsConst.repeatOptionsFrequency[0].id:
      addingValues({
        current,
        endDate,
        resultDates,
        interval: values.interval,
        unit,
      });
      break;
    // for Weekly
    case addEditEventsConst.repeatOptionsFrequency[1].id: {
      const startOfWeek = startDate
        .clone()
        .startOf("isoWeek")
        .subtract(1, "day"); // ISO week starts on Monday
      const datesOfWeek = [];
      const selectedDay = values.daysOfWeek.map((res) =>
        res.dayOfWeek === 7 ? 0 : res.dayOfWeek
      );

      for (let i = 0; i < 7; i++) {
        const date = moment(startOfWeek.clone()).add(i, "day");
        if (selectedDay.includes(date.day())) {
          datesOfWeek.push(date);
        }
      }
      selectedDatesCheck({
        multipleDates: datesOfWeek,
        endDate,
        resultDates,
        interval: values.interval,
        unit,
      });

      break;
    }
    // for Monthly
    case addEditEventsConst.repeatOptionsFrequency[2].id: {
      // when user only selected first monday or any other week and day combination then this will run
      if (!values.daysOfMonth?.length) {
        // values.monthWeekNumber for which week
        // values.DaysOfWeek for which day

        addingValuesForSelectedAnyWeekdayFromMonth({
          current,
          endDate,
          resultDates,
          values,
          unit,
        });
        break;
      }
      const startOfMonth = moment(startDate.clone())
        .startOf("month")
        .format("YYYY-MM-DD"); // ISO starts of Month

      const datesOfMonth = [];
      // seperated selected dates from calendar
      const selectedDay = values.daysOfMonth.map((res) => res.day);
      // find last date of start date month
      const last = moment(startOfMonth).clone().endOf("month").date();
      for (let i = 0; i < last + 1; i++) {
        const date = moment(startOfMonth).clone().add(i, "day");
        // selected start date month
        if (selectedDay.includes(date.date())) {
          datesOfMonth.push(date);
        }
      }

      if (moment(startOfMonth).month() === 1) {
        // if user selected 29, 30 and 31 and start date month is february then next month dates should be selected
        const nextMonth = moment(startOfMonth)
          .clone()
          .add(1, "month")
          .startOf("month");
        const nextMonthLast = moment(nextMonth.clone()).endOf("month").date();
        // Handle overflow days (e.g., 30 or 31 in February)
        const overflowDays = selectedDay.filter((day) => day > last);
        overflowDays.forEach((day) => {
          // Only add if the date exists in next month
          if (day <= nextMonthLast) {
            const date = moment(nextMonth.clone()).date(day);
            datesOfMonth.push(date);
          }
        });
      } else if (last < 31 && selectedDay.includes(31)) {
        let date = moment().add(values.interval, "month").startOf("month");

        // Loop until we find a month with 31 days
        while (date.daysInMonth() < 31) {
          date.add(values.interval, "month");
        }

        // Set to the 31st of that month
        date.date(31);
        datesOfMonth.push(date);
      }
      selectedDatesCheck({
        multipleDates: datesOfMonth,
        endDate,
        resultDates,
        interval: values.interval,
        unit,
      });
      break;
    }
    case addEditEventsConst.repeatOptionsFrequency[3].id: {
      const startDateClone = startDate.clone();
      const multipleDates = values.monthsOfYear.map((res) =>
        moment({
          year: startDateClone.year(),
          month: res.month - 1,
          date: startDateClone.date(),
        })
      );
      if (values?.daysOfWeek?.length) {
        multipleDates.forEach((res) => {
          addingValuesForSelectedAnyWeekdayFromMonth({
            current: res,
            endDate,
            resultDates,
            values,
            unit,
          });
        });
        break;
      }

      selectedDatesCheck({
        multipleDates,
        endDate,
        resultDates,
        interval: values.interval,
        unit,
      });

      break;
    }
    default:
      break;
  }

  return resultDates;
};

export const everyDatesCheckExceptCustomFunction = (eventDetails) => {
  if (
    [
      addEditEventsConst.repeatedOptionsValues.month,
      addEditEventsConst.repeatedOptionsValues.year,
    ].includes(eventDetails?.repeatedType)
  ) {
    // this function can be used for every2ndweek month and year
    return everyRelatedCalculation(eventDetails);
  }
  if (
    eventDetails?.repeatedType ===
    addEditEventsConst.repeatedOptionsValues.custom
  ) {
    return everyCustomRelatedCalculation(eventDetails);
  }
  return new Map();
};
// function used for when all day event is not enabled then current date should be disabled according to end time

export const currentDateDisableAccToEndTime = (
  eventDetail,
  enabledDates,
  check
) => {
  if (
    !eventDetail?.isAllDayEvent &&
    moment(enabledDates).format("YYYY-MM-DD") ===
      moment().format("YYYY-MM-DD") &&
    check
  ) {
    if (eventDetail?.endTime) {
      const time = moment(eventDetail?.endTime);
      return moment().isAfter(
        moment({ hour: time.hour(), minute: time.minute() })
      );
    }
    return check;
  }
  return check;
};
export const disabledDatesForCalendar = (
  eventDetail,
  date,
  startDay,
  everyDatesCheckExceptCustom
) => {
  if (
    eventDetail?.repeatedType ===
    addEditEventsConst.repeatedOptionsValues.everyWeek
  ) {
    return currentDateDisableAccToEndTime(
      eventDetail,
      moment(date).format("YYYY-MM-DD"),
      date.getDay() !== startDay?.index
    );
  }
  if (
    eventDetail?.repeatedType !==
      addEditEventsConst.repeatedOptionsValues.everyDay &&
    eventDetail?.repeatedType >
      addEditEventsConst.repeatedOptionsValues.everyWeek &&
    eventDetail?.repeatedType < 8
  ) {
    if (moment(date).isBefore(moment().subtract(1, "day"))) {
      return true;
    }
    return !everyDatesCheckExceptCustom.some((enabledDates) =>
      currentDateDisableAccToEndTime(
        eventDetail,
        enabledDates,
        enabledDates === moment(date).format("YYYY-MM-DD")
      )
    );
  }
  return currentDateDisableAccToEndTime(
    eventDetail,
    moment(date).format("YYYY-MM-DD"),
    false
  );
};

// recurrence logic

// everyDatesCheckExceptCustomFunction(eventDetails)
// This is the primary entry point for generating a list of all dates an event will occur on. It acts as a dispatcher:

// If the event has a simple recurrence (repeatedType is monthly, yearly, etc.), it calls everyRelatedCalculation to get the dates.
// If the event has a complex, user-defined recurrence (repeatedType is 'custom'), it calls everyCustomRelatedCalculation.
// It returns a final array of all calculated date strings in "YYYY-MM-DD" format.
// disabledDatesForCalendar(eventDetail, date, ...)
// This function is designed to be used with a calendar UI component (like a date picker). Its purpose is to determine if a specific date should be disabled (i.e., not selectable).

// For simple weekly events, it disables any day that doesn't match the event's weekday.
// For all other recurring events, it checks if the given date is not in the list of valid recurring dates generated by everyDatesCheckExceptCustomFunction.
// It also prevents the selection of past dates and disables "today" if the event's end time has already passed.
// ## Core Calculation Logic
// These functions contain the core logic for calculating different types of recurring schedules.

// everyRelatedCalculation(eventDetailModal)
// This function handles simple, non-custom recurrence rules.

// Case 4 (Bi-weekly): Calculates dates that occur every 2 weeks on the same day of the week as the start date.
// Case 5 (Monthly): Calculates dates that occur on the same day of the month, every month.
// Case 6 (Yearly): Calculates dates that occur on the same day and month, every year.
// everyCustomRelatedCalculation(eventDetailModal)
// This function is more complex and handles "custom" recurrence patterns set by the user. It uses a switch statement based on the frequency unit (daily, weekly, monthly, yearly).

// Daily: Calculates dates repeating every n days.
// Weekly: Calculates dates repeating every n weeks on specific user-selected days (e.g., every 2 weeks on Monday and Friday).
// Monthly: This is the most complex. It supports two modes:
// By Date: Repeats every n months on specific dates (e.g., the 1st and 15th). It includes logic to handle dates that don't exist in every month, like the 31st.
// By Weekday: Repeats every n months on a specific weekday of a specific week (e.g., the "second Tuesday" or "last Friday").
// Yearly: Calculates dates repeating every n years on specific user-selected months.
// ## Helper Functions
// These are smaller, reusable functions that support the core logic.

// addingValues(...): A generic loop that generates a sequence of dates by repeatedly adding a given interval and unit (e.g., add 1 'month') until an endDate is reached.
// selectedDatesCheck(...): A helper that applies a recurring interval to a starting set of multiple dates. This is used for patterns like "every week on Monday and Wednesday."
// getWeekDates(...): A specialized function to find a date based on its weekday and week number within a month (e.g., find the "third Monday" of June 2025).
// addingValuesForSelectedAnyWeekdayFromMonth(...): Uses getWeekDates to generate dates for monthly events that occur on, for example, the first Monday of every month.
// currentDateDisableAccToEndTime(...): A small utility that checks if the current time is already past an event's end time for today. This is used to disable "today" in a date picker if the event is already over.
